import { render } from "./DeploymentName.vue?vue&type=template&id=c0ebfc7a&scoped=true"
import script from "./DeploymentName.vue?vue&type=script&lang=js"
export * from "./DeploymentName.vue?vue&type=script&lang=js"

import "./DeploymentName.vue?vue&type=style&index=0&id=c0ebfc7a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0ebfc7a"]])

export default __exports__